import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../regureStyles';

const LOB_LABEL_KEYS = {
  daily_sickness: 'screens.claimsScreen.lobDailySicknessAllowance',
  professional_liability: 'screens.claimsScreen.lobProfessionalLiabilityEO',
  legal_protection: 'screens.claimsScreen.lobLegalProtection',
  property: 'screens.claimsScreen.lobProperty',
  workers_comp: 'screens.claimsScreen.lobWorkersComp',
  auto: 'screens.claimsScreen.lobAuto',
};

const PRIORITY_KEYS = {
  critical: 'screens.claimsScreen.new.priorityCritical',
  high: 'screens.claimsScreen.new.priorityHigh',
  medium: 'screens.claimsScreen.new.priorityMedium',
  low: 'screens.claimsScreen.new.priorityLow',
};

const REPORTED_KEYS = {
  claimant: 'screens.claimsScreen.new.reportedClaimant',
  broker: 'screens.claimsScreen.new.reportedBroker',
  third_party: 'screens.claimsScreen.new.reportedThirdParty',
};

const Step4 = ({ formData, S }) => {
  const { t } = useTranslation();
  const productLabel = LOB_LABEL_KEYS[formData.lineOfBusiness] ? t(LOB_LABEL_KEYS[formData.lineOfBusiness]) : (formData.lineOfBusiness || '—');
  const priorityLabel = PRIORITY_KEYS[formData.priority] ? t(PRIORITY_KEYS[formData.priority]) : t('screens.claimsScreen.new.priorityMedium');
  const reportedLabel = REPORTED_KEYS[formData.reportedBy] ? t(REPORTED_KEYS[formData.reportedBy]) : t('screens.claimsScreen.new.reportedClaimant');
  const items = [
    { label: t('screens.claimsScreen.new.reviewClaimant'), value: [formData.claimantName, formData.company].filter(Boolean).join(' — ') || '—' },
    { label: t('screens.claimsScreen.new.reviewPolicy'), value: formData.policyNumber || '—' },
    { label: t('screens.claimsScreen.new.reviewProduct'), value: productLabel },
    { label: t('screens.claimsScreen.new.reviewLossDate'), value: formData.lossDate ? formatDate(formData.lossDate) : '—' },
    { label: t('screens.claimsScreen.new.reviewPriority'), value: priorityLabel },
    { label: t('screens.claimsScreen.new.reviewReportedBy'), value: reportedLabel },
    { label: t('screens.claimsScreen.new.reviewDescription'), value: formData.description || '—' },
  ];
  return (
    <div>
      <div style={{ fontSize: 17, fontWeight: 700, color: S.textPrimary, marginBottom: 6 }}>{t('screens.claimsScreen.new.step4Title')}</div>
      <div style={{ fontSize: 13, color: S.textMuted, marginBottom: 24 }}>{t('screens.claimsScreen.new.step4Desc')}</div>
      <div style={{ background: S.bgCard, border: `1px solid ${S.borderLight}`, borderRadius: 14, padding: 24 }}>
        {items.map(item => (
          <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: `1px solid ${S.borderLight}` }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: S.textMuted, minWidth: 120 }}>{item.label}</span>
            <span style={{ fontSize: 13, color: S.textPrimary, textAlign: 'right', flex: 1 }}>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Step4;
